import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import MDButton from "../../MDButton";
import { CircularProgress } from "@mui/material";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { storeDriver } from "../../../actions/driver/driver";
import ModalMachineTypeSingle from "../../Modal/MachineType/MachineTypeSingle";
import ModalMachineGroupSingle from "../../Modal/MachineGroup/MachineGroupSingle";
import ModalDriverSingle from "../../Modal/Driver/DriverSingle";
import { storeMachine } from "../../../actions/machines/machines";
import ModalDrivers from "../../Modal/Driver/DriverModal";
import { Button } from "@heroui/button";
import { Datepicker } from "@ijavad805/react-datepicker";
import ModalSelectPeymankar from "../../Modal/Peymankar/PeymankarSelectModal";

export default function CreateMachineComponent(){
    const router = useNavigate();
    const [pending , setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [openModalGroup, setOpenModalGroup] = useState(false);
    const [openModalDriver, setOpenModalDriver] = useState(false);
    const [machineType, setDataMachineType] = useState({});
    const [machineGroup, setDataMachineGroup] = useState({});
    const [driver, setDriver] = useState([]);
    const [isOptionSelected, setIsOptionSelected] = useState(false);
    const [title, setTitle] = useState("");
    const [firstTwoDigits, setFirstTwoDigits] = useState("");
    const [middleThreeDigits, setMiddleThreeDigits] = useState("");
    const [letterDigit, setLetterDigit] = useState("");
    const [lastTwoDigits, setLastTwoDigits] = useState("");
    const [empty_weight, setEmptyWeight] = useState("");
    const [peymankar_id, setPeymankarId] = useState("");
    const [start_date, setStartDate] = useState("");
    const [end_date, setEndDate] = useState("");
    const [start_work_date, setStartWorkDate] = useState("");
    const [contract_number, setContractNumber] = useState("");
    const [ownership_type, setOwnershipType] = useState("تملیکی");
    const [machine_code, setMachineCode] = useState("");
    const [machine_id, setMachineId] = useState("");
    const [dataPeymankar , setDataPeymankar] = useState({id:"",title:""});
    const [openModalPeymankar, setOpenModalPeymankar] = useState(false);

    async function storeNewMachine(e) {
        e.preventDefault();
        const jsonData = {
            title: title,
            empty_weight: empty_weight,
            pelak: `${firstTwoDigits}${letterDigit}${middleThreeDigits}${lastTwoDigits}`,
            type_id: machineType.id || '',
            group_id: machineGroup.id || '',
            drivers: driver.map((d) => d.id),
            peymankar_id: dataPeymankar.id,
            start_date: start_date,
            end_date: end_date,
            start_work_date: start_work_date,
            contract_number: contract_number,
            ownership_type: ownership_type,
            machine_code: machine_code,
            machine_id: machine_id
        };

        setLoading(true);
        const state = await storeMachine(jsonData);
        setLoading(false);

        if (state.status === "success") {
            toast.success(state.message);
            router('/machines');
        } else {
            toast.error(state.message);
        }
    }

    const changeTextColor = () => {
        setIsOptionSelected(true);
    };
    return (
      <>
          <ModalMachineTypeSingle showModal={openModal} setShowModal={(flag)=>{
              setOpenModal(flag);
          }} onSelectedIdsChange={(data)=>{
              setOpenModal(false);
              setDataMachineType(data);
          }} setData={""} />
          <ModalMachineGroupSingle showModal={openModalGroup} setShowModal={(flag)=>{
              setOpenModalGroup(flag);
          }} onSelectedIdsChange={(data)=>{
              setOpenModalGroup(false);
              setDataMachineGroup(data);
          }} setData={""} />
          <ModalDrivers showModal={openModalDriver} setShowModal={(flag)=>{
              setOpenModalDriver(flag);
          }} onSelectedIdsChange={(data)=>{
              setOpenModalDriver(false);
              setDriver(data);
          }} setData={""} />
          <ModalSelectPeymankar setShowModal={(state)=>{
              setOpenModalPeymankar(state)
          }} setData={""} onSelectedIdsChange={(data)=>{
              setDataPeymankar(data);
          }} showModal={openModalPeymankar} />
          <DashboardLayout>
              <div className="flex flex-col gap-9">
                  <form onSubmit={storeNewMachine}>
                      <div
                        className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
                          <div className="border-b border-stroke px-6 py-4 dark:border-strokedark">
                              <h3 className="font-medium text-black dark:text-white">
                                  ثبت دستگاه
                              </h3>
                          </div>
                          <div className="flex flex-col gap-5 p-6">
                              <div className="grid grid-cols-3 gap-5">
                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          نام دستگاه
                                      </label>
                                      <input
                                        required
                                        type="text"
                                        value={title}
                                        onChange={(e)=>setTitle(e.target.value)}
                                        name='title'
                                        placeholder="..."
                                        className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                      />
                                  </div>

                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          کد دستگاه
                                      </label>
                                      <input
                                        type="text"
                                        value={machine_code}
                                        onChange={(e)=>setMachineCode(e.target.value)}
                                        placeholder="..."
                                        className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                      />
                                  </div>

                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          شناسه دستگاه
                                      </label>
                                      <input
                                        type="text"
                                        value={machine_id}
                                        onChange={(e)=>setMachineId(e.target.value)}
                                        placeholder="..."
                                        className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                      />
                                  </div>

                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          پلاک
                                      </label>
                                      <div
                                        className="w-full bg-white p-2.5 text-xl rounded-md border border-black relative inline-flex items-center space-x-2"
                                      >
                                          <div
                                            className="absolute top-0 left-0 h-full w-8 bg-blue-800 rounded-l-md text-white text-xs flex flex-col justify-center items-center"
                                          >
                                              <span className="leading-none">IR</span>
                                              <span className="leading-none">IRAN</span>
                                          </div>
                                          <div
                                            className="flex justify-center items-center pl-2 border-l border-black font-vazir">
                                              <input
                                                required
                                                type="text"
                                                maxLength={2}
                                                value={lastTwoDigits}
                                                onChange={(e) => setLastTwoDigits(e.target.value)}
                                                className="text-center border border-gray-400 rounded px-1 w-12"
                                              />
                                          </div>
                                          <div
                                            className="flex flex-grow justify-center items-center gap-5 text-center font-vazir">
                                              <input
                                                required
                                                type="text"
                                                maxLength={3}
                                                value={middleThreeDigits}
                                                onChange={(e) => setMiddleThreeDigits(e.target.value)}
                                                className="text-center border border-gray-400 rounded px-1 w-12"
                                              />
                                              <input
                                                required
                                                type="text"
                                                maxLength={1}
                                                value={letterDigit}
                                                onChange={(e) => setLetterDigit(e.target.value)}
                                                className="text-center border border-gray-400 rounded px-1 w-12"
                                              />
                                              <input
                                                required
                                                type="text"
                                                maxLength={2}
                                                value={firstTwoDigits}
                                                onChange={(e) => setFirstTwoDigits(e.target.value)}
                                                className="text-center border border-gray-400 rounded px-1 w-12"
                                              />
                                          </div>
                                      </div>
                                  </div>

                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          نوع مالکیت
                                      </label>
                                      <select
                                        value={ownership_type}
                                        onChange={(e) => setOwnershipType(e.target.value)}
                                        className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                      >
                                          <option value="تملیکی">تملیکی</option>
                                          <option value="استیجاری">استیجاری</option>
                                          <option value="پیمانکاری">پیمانکاری</option>
                                      </select>
                                  </div>

                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          شماره قرارداد
                                      </label>
                                      <input
                                        type="text"
                                        value={contract_number}
                                        onChange={(e)=>setContractNumber(e.target.value)}
                                        placeholder="..."
                                        className="w-full rounded-lg text-sm border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                      />
                                  </div>

                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          پیمانکار
                                      </label>
                                      <input
                                        readOnly
                                        onClick={()=>{
                                            setOpenModalPeymankar(true);
                                        }}
                                        value={dataPeymankar['title']}
                                        onChange={(e)=>setPeymankarId(e.target.value)}
                                        placeholder="..."
                                        className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                      />
                                  </div>

                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          تاریخ شروع قرارداد
                                      </label>
                                      <Datepicker
                                        input={
                                            <input
                                              type="date"
                                              placeholder="تاریخ شروع قرارداد"
                                              className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                            />
                                        }
                                        adjustPosition="modal"
                                        onChange={(val) => {
                                            setStartDate(val.format());
                                        }}
                                        value={start_date}
                                      />
                                  </div>

                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          تاریخ پایان قرارداد
                                      </label>
                                      <Datepicker
                                        input={
                                            <input
                                              type="date"
                                              placeholder="تاریخ پایان قرارداد"
                                              className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                            />
                                        }
                                        adjustPosition="modal"
                                        onChange={(val) => {
                                            setEndDate(val.format());
                                        }}
                                        value={end_date}
                                      />
                                  </div>

                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          تاریخ شروع کار
                                      </label>
                                      <Datepicker
                                        input={
                                            <input
                                              type="date"
                                              placeholder="تاریخ شروع کار"
                                              className="w-full rounded-lg text-sm border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                            />
                                        }
                                        adjustPosition="modal"
                                        onChange={(val) => {
                                            setStartWorkDate(val.format());
                                        }}
                                        value={start_work_date}
                                      />
                                  </div>

                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          نوع دستگاه
                                      </label>
                                      <input
                                        onClick={() => {
                                            setOpenModal(true);
                                        }}
                                        type="text"
                                        value={machineType.title}
                                        readOnly
                                        placeholder="..."
                                        className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                      />
                                  </div>

                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          گروه دستگاه
                                      </label>
                                      <input
                                        onClick={() => {
                                            setOpenModalGroup(true);
                                        }}
                                        type="text"
                                        value={machineGroup.title}
                                        readOnly
                                        placeholder="..."
                                        className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                      />
                                  </div>

                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          راننده
                                      </label>
                                      <input
                                        onClick={() => {
                                            setOpenModalDriver(true);
                                        }}
                                        type="text"
                                        value={driver.map((d) => d.name).join(" - ")}
                                        readOnly
                                        placeholder="..."
                                        className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                      />
                                  </div>

                                  <div className="flex-1">
                                      <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                                          وزن خالی
                                      </label>
                                      <input
                                        type="number"
                                        value={empty_weight}
                                        onChange={(e)=>setEmptyWeight(e.target.value)}
                                        name='empty_weight'
                                        placeholder="..."
                                        className="w-full text-sm rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                      />
                                  </div>
                              </div>

                              <div className={"flex mt-10 w-1/5"}>
                                  <Button isLoading={pending} type={"submit"} variant="gradient"
                                          className="!bg-blue-500 !py-5 hover:bg-blue-600 text-white w-full">
                                      ایجاد
                                  </Button>
                              </div>
                          </div>
                      </div>
                  </form>
              </div>
          </DashboardLayout>
      </>
    );
}